module.exports = "/_next/static/images/12282368c144acb16b4dee780136b46b-card-background-right-lg.jpg";